export const UPDATE_SETTINGS = 'app/controls/UPDATE_SETTINGS';
